import { environment } from "../../environments/environment";

/**
 * This class is used to log data to the browser console.
 */
export class Logger {

// #region [ Static Methods ]

	/**
	 * Logs a message to the console if verbose logging is turned on.
	 *
	 * @param Message The string to log to the console.
	 */
	public static Log(Message: string): void {
		if(environment.VerboseLogging) {
			console.log(Message); 
		}
	}

	/**
	 * Logs an error to the console.
	 *
	 * @param SourceFunction The source method of the error in the form of ClassName.MethodName.
	 * @param Message The string to log to the console.
	 */
	public static LogError(SourceFunction: string, Message: string): void {
		console.log(`Error in ${SourceFunction}\n${Message}`);
	}

	/**
	 * Logs the start of a service call to the console.
	 *
	 * @param Method The HTTP method used for this request.
	 * @param Url The URL being queried.
	 * @param Data The data being sent as the body of the request.
	 * @returns A unique identifier used to match this request with it's corresponding response.
	 */
	public static ServiceStartLog(Method: string, Url: string, Data: object): number {
		let intIdentifier;

		if (environment.VerboseLogging) {
			intIdentifier = Math.floor(Math.random() * 1000);
			console.log(
				`About to ${Method}\
        URL: ${Url}\
        Identifier: ${intIdentifier}`
			);
		}
		if (Data != null)
			console.log(Data);

		return intIdentifier;
	}

	/**
	 * Logs the end of a service call to the console.
	 *
	 * @param Identifier The identifier of the corresponding request.
	 * @param Method The HTTP method used for this request.
	 * @param Url The URL that was queried.
	 * @param Data The data returned by the service call.
	 */
	public static ServiceEndLog(Identifier: number, Method: string, Url: string, Data: object): void {
		if (environment.VerboseLogging) {
			console.log(
				`${Method} request completed.\
         URL: ${Url}\
         Identifier: ${Identifier}`
			);
			if (Data != null)
				console.log(Data);
		}
	}
	
}
